$('.btn-menu').on('click', function(){
	$(this).toggleClass('btn-menu-open');
})